document.addEventListener("DOMContentLoaded", () => {
    const onOverlays = document.querySelectorAll('.js--on-overlay');
    onOverlays.forEach(onOverlay => {

        onOverlay.addEventListener('click', (e) => {
            const overlay = e.currentTarget.dataset.overlay;
            document.querySelector(`#${overlay}`).style.display = "block";
        })
    })

    const offOverlays = document.querySelectorAll('.js--off-overlay');
    offOverlays.forEach(offOverlay => {

        offOverlay.addEventListener('click', () => {
            const overlays = document.querySelectorAll('.js--overlay__banner');
            overlays.forEach(overlay => {
                overlay.style.display = 'none';
            })
        })
    })
});